import { Tooltip } from '@sgme/ui';
import { useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';

import { useTrackEvent } from '@/App/VoiceTimestamping/useTrackEvent.ts';
import { nonReduxStateContext } from '@/context/nonReduxStateContext.tsx';

export const VoiceTimestampingHeaderButton = () => {
  const { formatMessage } = useIntl();
  const trackEvent = useTrackEvent();
  const { showVoiceTimestampingPanel, setShowVoiceTimestampingPanel } = useContext(nonReduxStateContext);

  const handleClick = useCallback(() => {
    setShowVoiceTimestampingPanel(!showVoiceTimestampingPanel);
    trackEvent(`${showVoiceTimestampingPanel ? 'Close' : 'Open'} Mifid2 panel`);
  }, [setShowVoiceTimestampingPanel, showVoiceTimestampingPanel]);

  return (
    <Tooltip contents={formatMessage({ id: 'voiceTimestamping.headerButtonTooltip' })} position="bottom">
      <button type="button" className="h-100 btn btn-flat-primary btn-icon btn-nav btn-lg p-2" onClick={handleClick}>
        <i className="icon icon-md">perm_phone_msg</i>
      </button>
    </Tooltip>
  );
};
